import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {getFulfillmentLineItems} from "../../utils/fulfillment-line-items.util";

export class FulfillmentTableRowComponent implements IController {

  fulfillment: any;
  columns: any;
  dynamicColumns: any;
  packageDynamicColumns: any;
  isCollapse: boolean;
  isSelected: string;
  fulfillmentSelectedSteps: any[];
  excludeMode: boolean;
  onOpen: Function;
  onDispatch: Function;
  onToggleSelect: Function;
  onCancelOrder: Function;
  onEditOrder: Function;
  onAddOrderNote: Function;
  onDuplicateOrder: Function;
  onPrintBillOfLading: Function;
  onDownloadBillOfLading: Function;
  onSetOrderOnHold: Function;
  onFilterByType: Function;
  onCreateVoucher: Function;
  onRestoreFulfillment: Function;

  public fulfillmentLinesStepProgress: any = {};
  public fulfillmentLinesSteps: any = {};
  public fulfillmentSteps: any = [];
  public fulfillmentLinesItems: any = {};
  public filteredStepsCount: number = 0;
  public isChecked: boolean = false;
  public isPartiallyChecked: boolean = false;
  public locationTypes: typeof LocationType = LocationType;
  public fulfillmentLineItemsIds: string[] = [];
  public fulfillmentLineItems: string[] = [];
  public fulfillmentLineItemsBarcodes: string[] = [];
  public fulfillmentLineItemsDescription: string[] = [];
  public sitePackageItemsMap: any;
  public canCopyProgramName: boolean = false;
  public canCopyPickupDepot: boolean;
  public canCopyDestinationDepot: boolean;
  public canCopyPickupCustomer: boolean;
  public canCopyDestinationCustomer: boolean;
  public canCopyPickupCustomContact: boolean;
  public canCopyDestinationCustomContact: boolean;
  public fulfillmentLinesPackagesDataMap: any = {};
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;


  constructor(private splitService, private fulfillmentDialogService: FulfillmentDialogService) {
  }

  $onInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this._setFulfillmentLinesSteps();
    this._getStepProgress();
    this._setFulfillmentLinesPackages();
    this._filteredSteps();
    this._isFulfillmentChecked();
    this._setFulfillmentLinesPackagesData();
  }

  $onChanges(changes) {
    if (changes.fulfillmentSelectedSteps && !changes.fulfillmentSelectedSteps.isFirstChange() || changes.excludeMode && !changes.excludeMode.isFirstChange()) {
      this._isFulfillmentChecked();
    }
    if (changes.fulfillment && !changes.fulfillment.isFirstChange()) {
      this._setFulfillmentLinesSteps();
      this._getStepProgress();
      this._setFulfillmentLinesPackages();
      this._isFulfillmentChecked();
      this._setFulfillmentLinesPackagesData();
    }
  }

  onViewPods(fulfillmentSteps, event) {
    this.fulfillmentDialogService.identificationsImages(fulfillmentSteps);
  }

  private _setFulfillmentLinesPackagesData() {
    const lastMileSteps = _.filter(this.fulfillment.fulfillmentSteps, s => {
      return s.lastMile
    });

    _.forEach(lastMileSteps, s => {

      if (!this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId]) {
        this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId] = {
          count: 0,
          countGap: 0,
          weight: 0,
          weightGap: 0
        };
      }

      _.forEach(s.items, i => {
        const fulfillmentPackageItem = _.find(this.fulfillment.packages, p => {
          return p.id === i.id
        });
        this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId].count += fulfillmentPackageItem.count;
        this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId].weight += (fulfillmentPackageItem.weight * fulfillmentPackageItem.count);
      })

      _.forEach(s.items, i => {
        if (!_.isUndefined(i.actualCount)) {
          this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId].countGap += i.actualCount - i.count;
          this.fulfillmentLinesPackagesDataMap[s.fulfillmentLineId].weightGap += (i.actualWeight * i.actualCount - i.weight * i.count);
        }
      })

    })
  }

  private _setFulfillmentLinesSteps() {
    this.fulfillmentLinesSteps = {};
    this.fulfillmentSteps = [];
    _.forEach(_.get(this.fulfillment, 'linesInfo', []), line => {
      this.fulfillmentLinesSteps[line.id] = [];
    });
    _.forEach(_.get(this.fulfillment, 'fulfillmentSteps', []), step => {
      if (step.fulfillmentLineId) {
        this.fulfillmentLinesSteps[step.fulfillmentLineId].push(step);
        this.fulfillmentSteps.push(step);
      }
    });
  }

  private _filteredSteps() {
    _.forEach(this.fulfillment.fulfillmentSteps, step => {
      if (step.matchFilter) {
        this.filteredStepsCount += 1;
      }
    })
  }

  private _getStepProgress() {
    _.forOwn(this.fulfillmentLinesSteps, (fulfillmentLineSteps, fulfillmentLineId) => {
      let completedCount = 0;
      _.forEach(fulfillmentLineSteps, step => {
        completedCount += step.status === 'Completed' ? 1 : 0;
      })
      this.fulfillmentLinesStepProgress[fulfillmentLineId] = {
        stepNumber: completedCount,
        numberOfSteps: fulfillmentLineSteps.length
      }
    });
  }

  private _setFulfillmentLinesPackages() {
    _.forEach(this.fulfillment.linesInfo, fulfillmentLine => {
      this.fulfillmentLinesItems[fulfillmentLine.id] = getFulfillmentLineItems(fulfillmentLine, _.get(this.fulfillment, 'items', []))
    })
    _.forOwn(this.fulfillmentLinesItems, (i, key) => {
      this.fulfillmentLineItemsIds[key] = _.map(i, 'id')
      this.fulfillmentLineItemsBarcodes[key] = _.chain(i)
        .filter(item => {
          return item.barcode
        })
        .map(item => {
          return item.barcode
        })
        .value();
      this.fulfillmentLineItems[key] = _.map(i, item => {
        return this.sitePackageItemsMap[item?.type];
      })
      this.fulfillmentLineItemsDescription[key] = _.chain(i)
        .filter(item => {
          return item.description
        })
        .map(item => {
          return item.description
        })
        .value();
    })
  }

  private _isFulfillmentChecked() {
    const stepsMatchedFilterCount = _.filter(this.fulfillment.fulfillmentSteps, (s) => {
      return !!s.matchFilter;
    }).length

    const selectedStepsInFilterCount = _.filter(this.fulfillmentSelectedSteps, (id) => {
      return _.find(this.fulfillment.fulfillmentSteps, (step) => {
        return !!step.matchFilter && _.isEqual(step.id, id);
      })
    }).length
    const selectedStepsOutOfFilterCount = _.filter(this.fulfillmentSelectedSteps, (id) => {
      return _.find(this.fulfillment.fulfillmentSteps, (step) => {
        return !step.matchFilter && _.isEqual(step.id, id);
      })
    }).length

    this.isChecked = !this.excludeMode ? (selectedStepsInFilterCount + selectedStepsOutOfFilterCount === this.fulfillment.fulfillmentSteps.length) : ((stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) > 0)

    this.isPartiallyChecked = !this.excludeMode ?
      ((selectedStepsInFilterCount + selectedStepsOutOfFilterCount > 0) && (selectedStepsInFilterCount + selectedStepsOutOfFilterCount !== this.fulfillment.fulfillmentSteps.length)) :
      (((stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) > 0) && (stepsMatchedFilterCount - selectedStepsInFilterCount + selectedStepsOutOfFilterCount) < this.fulfillment.fulfillmentSteps.length);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTableRow', {
    require: {
      fulfillmentsTableCtrl: '^fulfillmentsTable'
    },
    bindings: {
      fulfillment: '<',
      columns: '<',
      dynamicColumns: '<',
      packageDynamicColumns: '<',
      isCollapse: '<',
      isSelected: '<',
      fulfillmentSelectedSteps: '<',
      excludeMode: '<',
      onToggleSelect: '&',
      onOpen: '&',
      onDispatch: '&',
      onCancelOrder: '&',
      onEditOrder: '&',
      onAddOrderNote: '&',
      onDuplicateOrder: '&',
      onPrintBillOfLading: '&',
      onDownloadBillOfLading: '&',
      onSetOrderOnHold: '&',
      onFilterByType: '&',
      onCreateVoucher: '&',
      onRestoreFulfillment: '&'
    },
    template: require('./fulfillment-table-row.html').default,
    controller: FulfillmentTableRowComponent
  });
